<template>
  <div
    class="dark:bg-gray-800 bg-sky-white text-grayLightMode-400 shadow-lg rounded-curl dark:text-gray-100 absolute w-full z-100"
  >
    <!-- if toggleLanguagesMenu is false then it hasn't been toggled -->
    <div v-if="!toggleLanguagesMenu" class="p-4 space-y-3">
      <div class="flex space-x-2 cursor-pointer select-none">
        <svg
          class="my-auto"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 10C12.0627 10 13.75 8.31246 13.75 6.25C13.75 4.18754 12.0627 2.5 10 2.5C7.9373 2.5 6.25 4.18754 6.25 6.25C6.25 8.31246 7.9373 10 10 10ZM10 11.875C7.5157 11.875 2.5 13.1407 2.5 15.625V17.5H17.5V15.625C17.5 13.1407 12.4843 11.875 10 11.875Z"
            fill="currentColor"
          />
        </svg>
        <router-link
          :to="{
            name: 'ProfileView',
            params: { username: currentUser.username },
          }"
        >
          <div class="font-bold my-auto">
            {{ $t("appBar.overlayProfileSettings.profile") }}
          </div>
        </router-link>
      </div>
      <div class="flex space-x-2 cursor-pointer select-none">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.1707 10.8125C16.2121 10.5689 16.2121 10.2844 16.2121 9.99996C16.2121 9.71551 16.1707 9.47191 16.1707 9.18746L17.9155 7.84691C18.0819 7.72512 18.1233 7.52203 17.9987 7.31887L16.3366 4.51559C16.2535 4.35293 16.0043 4.27203 15.8379 4.35293L13.7603 5.16547C13.3448 4.84055 12.8465 4.55605 12.3478 4.35293L12.0569 2.19992C12.0155 2.03766 11.8491 1.875 11.6413 1.875H8.3172C8.10947 1.875 7.9431 2.03766 7.90169 2.19992L7.56935 4.35293C7.07064 4.55605 6.61373 4.84051 6.15642 5.16547L4.07884 4.35293C3.87107 4.27203 3.6633 4.35293 3.58013 4.51559L1.91806 7.31891C1.83529 7.48113 1.87662 7.72511 2.00122 7.84695L3.78798 9.18746C3.78798 9.47191 3.74658 9.71551 3.74658 9.99996C3.74658 10.2844 3.78798 10.528 3.78798 10.8125L2.04314 12.153C1.87673 12.2748 1.8354 12.4779 1.95994 12.6811L3.62201 15.4843C3.70521 15.647 3.95435 15.7279 4.12072 15.647L6.19833 14.8344C6.61384 15.1594 7.11216 15.4439 7.61083 15.647L7.94318 17.8C7.98494 18.0031 8.15091 18.1249 8.35869 18.1249H11.6828C11.8906 18.1249 12.057 17.9623 12.0984 17.8L12.4311 15.647C12.9294 15.4439 13.3867 15.1594 13.8436 14.8344L15.9212 15.647C16.129 15.7279 16.3367 15.647 16.4199 15.4843L18.082 12.681C18.1652 12.5188 18.1234 12.2748 17.9988 12.153L16.1707 10.8125ZM9.97931 12.8437C8.35865 12.8437 7.07072 11.5845 7.07072 9.99996C7.07072 8.41539 8.35865 7.15621 9.97931 7.15621C11.6 7.15621 12.8879 8.41539 12.8879 9.99996C12.8879 11.5845 11.6 12.8437 9.97931 12.8437Z"
            fill="currentColor"
          />
        </svg>

        <router-link :to="{ name: 'SettingsView' }">
          <div class="font-bold">
            {{ $t("appBar.overlayProfileSettings.settings") }}
          </div>
        </router-link>
      </div>
      <div
        @click="toggleLanguagesMenu = !toggleLanguagesMenu"
        class="flex justify-between cursor-pointer select-none"
      >
        <div class="flex space-x-2">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 1.875H9.97266C7.80859 1.88281 5.77734 2.73047 4.24609 4.26172C2.71875 5.79688 1.875 7.83203 1.875 10C1.875 12.168 2.71875 14.2031 4.25 15.7383C5.77734 17.2695 7.8125 18.1172 9.97656 18.125H10.0039C14.4844 18.125 18.1289 14.4805 18.1289 10C18.1289 5.51953 14.4805 1.875 10 1.875ZM17.0391 9.45312H14.0078C13.9727 8.41016 13.8437 7.41406 13.625 6.47656C14.293 6.26172 14.9414 5.98828 15.5664 5.65625C16.4258 6.75781 16.9336 8.0625 17.0391 9.45312ZM9.45312 9.45312H7.03906C7.07031 8.49609 7.1875 7.58984 7.38281 6.75391C8.0625 6.90625 8.75391 7 9.45312 7.03125V9.45312ZM9.45312 10.5469V12.9648C8.75781 12.9961 8.0625 13.0898 7.38281 13.2422C7.1875 12.4062 7.07031 11.5 7.03906 10.5469H9.45312ZM10.5469 10.5469H12.9414C12.9102 11.5 12.793 12.4062 12.5977 13.2383C11.9258 13.0859 11.2383 12.9961 10.5469 12.9648V10.5469ZM10.5469 9.45312V7.03125C11.2422 7 11.9297 6.90625 12.5977 6.75781C12.793 7.59375 12.9102 8.49609 12.9414 9.45312H10.5469ZM14.8203 4.84766C14.3398 5.08594 13.8438 5.28906 13.3359 5.45313C13.0586 4.61719 12.707 3.89453 12.3008 3.32422C13.2383 3.64844 14.0938 4.16797 14.8203 4.84766ZM12.3047 5.73438C11.7305 5.85938 11.1406 5.9375 10.5469 5.96875V3.10156C11.2109 3.46094 11.8594 4.42578 12.3047 5.73438ZM9.45312 3.08594V5.96484C8.85156 5.93359 8.25781 5.85547 7.67578 5.72656C8.12891 4.40625 8.78516 3.44141 9.45312 3.08594ZM7.67188 3.33594C7.26953 3.90234 6.92188 4.62109 6.64453 5.44922C6.14453 5.28516 5.65234 5.08203 5.17969 4.84766C5.89844 4.17188 6.74609 3.65625 7.67188 3.33594ZM4.43359 5.66016C5.05078 5.98828 5.69531 6.26172 6.35547 6.47266C6.13281 7.40625 6.00391 8.40625 5.97266 9.44922H2.96484C3.06641 8.06641 3.57422 6.76172 4.43359 5.66016ZM2.96094 10.5469H5.96875C6.00391 11.5898 6.13281 12.5898 6.35156 13.5234C5.69141 13.7383 5.04688 14.0117 4.42969 14.3359C3.57422 13.2383 3.06641 11.9336 2.96094 10.5469ZM5.17578 15.1523C5.64844 14.918 6.14063 14.7148 6.64453 14.5508C6.92188 15.3828 7.26953 16.0977 7.67188 16.668C6.74609 16.3398 5.89844 15.8281 5.17578 15.1523ZM7.67578 14.2695C8.25781 14.1406 8.85547 14.0625 9.45312 14.0312V16.9141C8.78125 16.5586 8.12891 15.5898 7.67578 14.2695ZM10.5469 16.8984V14.0273C11.1406 14.0586 11.7305 14.1367 12.3047 14.2617C11.8594 15.5742 11.2109 16.5391 10.5469 16.8984ZM12.3047 16.6758C12.7109 16.1055 13.0625 15.3828 13.3398 14.5469C13.8477 14.7109 14.3477 14.918 14.8242 15.1562C14.0977 15.832 13.2383 16.3516 12.3047 16.6758ZM15.5664 14.3398C14.9414 14.0078 14.293 13.7344 13.625 13.5195C13.8437 12.5859 13.9727 11.5898 14.0078 10.5469H17.0391C16.9336 11.9336 16.4297 13.2383 15.5664 14.3398Z"
              fill="currentColor"
            />
          </svg>
          <div class="font-bold">
            {{ $t("appBar.overlayProfileSettings.language") }}
          </div>
        </div>
        <svg
          class="my-auto text-grayLightMode-300"
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.9302 7.50024L9.20654 3.77954C8.93115 3.50415 8.93115 3.05884 9.20654 2.78638C9.48193 2.51392 9.92724 2.51392 10.2026 2.78638L14.4214 7.0022C14.688 7.2688 14.6938 7.69653 14.4419 7.97192L10.2056 12.217C10.0679 12.3547 9.88623 12.4221 9.70752 12.4221C9.52881 12.4221 9.34717 12.3547 9.20947 12.217C8.93408 11.9417 8.93408 11.4963 9.20947 11.2239L12.9302 7.50024Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <div class="flex space-x-2 cursor-pointer select-none">
        <svg
          class="my-auto"
          width="20"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 0C10.8661 0 14 3.13352 14 6.99915C14 10.8648 10.8661 13.9983 7 13.9983C5.86756 13.9998 4.7518 13.7254 3.7492 13.199L0.746206 13.9808C0.645865 14.0069 0.540437 14.0064 0.44037 13.9792C0.340302 13.9521 0.249071 13.8992 0.175717 13.826C0.102363 13.7527 0.0494328 13.6615 0.022173 13.5615C-0.00508687 13.4615 -0.00573025 13.356 0.0203066 13.2557L0.801506 10.2537C0.273566 9.25021 -0.00155376 8.13305 6.60034e-06 6.99915C6.60034e-06 3.13352 3.13391 0 7 0ZM7 9.44885C6.81435 9.44885 6.6363 9.52259 6.50503 9.65385C6.37375 9.78511 6.3 9.96313 6.3 10.1488C6.3 10.3344 6.37375 10.5124 6.50503 10.6437C6.6363 10.7749 6.81435 10.8487 7 10.8487C7.18566 10.8487 7.3637 10.7749 7.49498 10.6437C7.62625 10.5124 7.7 10.3344 7.7 10.1488C7.7 9.96313 7.62625 9.78511 7.49498 9.65385C7.3637 9.52259 7.18566 9.44885 7 9.44885ZM7 3.32459C6.48946 3.32459 5.99983 3.52738 5.63882 3.88834C5.27782 4.24931 5.075 4.73888 5.075 5.24936C5.07505 5.38236 5.12558 5.51039 5.21639 5.60757C5.3072 5.70475 5.43151 5.76385 5.56422 5.77291C5.69693 5.78198 5.82813 5.74034 5.93131 5.65641C6.0345 5.57248 6.10197 5.45251 6.1201 5.32075L6.1299 5.15977C6.15355 4.93724 6.26157 4.73223 6.43176 4.5869C6.60195 4.44157 6.82136 4.36697 7.04488 4.37845C7.26839 4.38992 7.47901 4.4866 7.63342 4.64859C7.78782 4.81058 7.87428 5.02558 7.875 5.24936C7.875 5.62661 7.7805 5.81279 7.4235 6.18165L7.2107 6.39862C6.6829 6.94735 6.475 7.3414 6.475 8.04902C6.475 8.18824 6.53032 8.32176 6.62877 8.4202C6.72723 8.51865 6.86076 8.57395 7 8.57395C7.13924 8.57395 7.27278 8.51865 7.37123 8.4202C7.46969 8.32176 7.525 8.18824 7.525 8.04902C7.525 7.67176 7.6195 7.48559 7.9765 7.11673L8.1893 6.89976C8.7171 6.35102 8.925 5.95697 8.925 5.24936C8.925 4.73888 8.72219 4.24931 8.36118 3.88834C8.00018 3.52738 7.51055 3.32459 7 3.32459Z"
            fill="currentColor"
          />
        </svg>
        <div class="font-bold">
          {{ $t("appBar.overlayProfileSettings.help") }}
        </div>
      </div>
      <div class="flex space-x-2 cursor-pointer select-none">
        <svg
          class="my-auto"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5 5.6875H14.8672C14.4453 4.95703 13.8633 4.32812 13.1602 3.85156L14.6875 2.32031L13.3672 1L11.332 3.03516C10.8984 2.92969 10.4609 2.875 10 2.875C9.53906 2.875 9.10156 2.92969 8.67969 3.03516L6.63281 1L5.3125 2.32031L6.83203 3.84766C6.13672 4.32422 5.55859 4.95312 5.13672 5.68359H2.5V7.55859H4.46094C4.41406 7.86719 4.375 8.17578 4.375 8.49609V9.43359H2.5V11.3086H4.375V12.2461C4.375 12.5664 4.41406 12.875 4.46094 13.1836H2.5V15.0586H5.13281C6.10937 16.7383 7.91797 17.8711 10 17.8711C12.082 17.8711 13.8906 16.7383 14.8672 15.0586H17.5V13.1836H15.5391C15.5859 12.875 15.625 12.5664 15.625 12.2461V11.3086H17.5V9.43359H15.625V8.49609C15.625 8.17578 15.5859 7.86719 15.5391 7.55859H17.5V5.6875Z"
            fill="currentColor"
          />
        </svg>

        <div class="font-bold">
          {{ $t("appBar.overlayProfileSettings.reportABug") }}
        </div>
      </div>
      <div
        @click="toggleDark()"
        class="flex space-x-2 cursor-pointer select-none"
      >
        <svg
          class="my-auto"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 3.5C11.7239 3.5 13.3772 4.18482 14.5962 5.40381C15.8152 6.62279 16.5 8.27609 16.5 10C16.5 11.7239 15.8152 13.3772 14.5962 14.5962C13.3772 15.8152 11.7239 16.5 10 16.5V3.5ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2V2Z"
            fill="currentColor"
          />
        </svg>
        <div class="font-bold">
          {{
            isDark
              ? $t("appBar.overlayProfileSettings.switchToLightMode")
              : $t("appBar.overlayProfileSettings.switchToDarkMode")
          }}
        </div>
      </div>
    </div>
    <!-- if the toggleLanguagesMenu is true -->
    <div v-else class="">
      <div
        @click="toggleLanguagesMenu = !toggleLanguagesMenu"
        class="flex justify-between cursor-pointer select-none px-5 py-3"
      >
        <div class="flex space-x-2">
          <svg
            class="my-auto"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 1.875H9.97266C7.80859 1.88281 5.77734 2.73047 4.24609 4.26172C2.71875 5.79688 1.875 7.83203 1.875 10C1.875 12.168 2.71875 14.2031 4.25 15.7383C5.77734 17.2695 7.8125 18.1172 9.97656 18.125H10.0039C14.4844 18.125 18.1289 14.4805 18.1289 10C18.1289 5.51953 14.4805 1.875 10 1.875ZM17.0391 9.45312H14.0078C13.9727 8.41016 13.8437 7.41406 13.625 6.47656C14.293 6.26172 14.9414 5.98828 15.5664 5.65625C16.4258 6.75781 16.9336 8.0625 17.0391 9.45312ZM9.45312 9.45312H7.03906C7.07031 8.49609 7.1875 7.58984 7.38281 6.75391C8.0625 6.90625 8.75391 7 9.45312 7.03125V9.45312ZM9.45312 10.5469V12.9648C8.75781 12.9961 8.0625 13.0898 7.38281 13.2422C7.1875 12.4062 7.07031 11.5 7.03906 10.5469H9.45312ZM10.5469 10.5469H12.9414C12.9102 11.5 12.793 12.4062 12.5977 13.2383C11.9258 13.0859 11.2383 12.9961 10.5469 12.9648V10.5469ZM10.5469 9.45312V7.03125C11.2422 7 11.9297 6.90625 12.5977 6.75781C12.793 7.59375 12.9102 8.49609 12.9414 9.45312H10.5469ZM14.8203 4.84766C14.3398 5.08594 13.8438 5.28906 13.3359 5.45313C13.0586 4.61719 12.707 3.89453 12.3008 3.32422C13.2383 3.64844 14.0938 4.16797 14.8203 4.84766ZM12.3047 5.73438C11.7305 5.85938 11.1406 5.9375 10.5469 5.96875V3.10156C11.2109 3.46094 11.8594 4.42578 12.3047 5.73438ZM9.45312 3.08594V5.96484C8.85156 5.93359 8.25781 5.85547 7.67578 5.72656C8.12891 4.40625 8.78516 3.44141 9.45312 3.08594ZM7.67188 3.33594C7.26953 3.90234 6.92188 4.62109 6.64453 5.44922C6.14453 5.28516 5.65234 5.08203 5.17969 4.84766C5.89844 4.17188 6.74609 3.65625 7.67188 3.33594ZM4.43359 5.66016C5.05078 5.98828 5.69531 6.26172 6.35547 6.47266C6.13281 7.40625 6.00391 8.40625 5.97266 9.44922H2.96484C3.06641 8.06641 3.57422 6.76172 4.43359 5.66016ZM2.96094 10.5469H5.96875C6.00391 11.5898 6.13281 12.5898 6.35156 13.5234C5.69141 13.7383 5.04688 14.0117 4.42969 14.3359C3.57422 13.2383 3.06641 11.9336 2.96094 10.5469ZM5.17578 15.1523C5.64844 14.918 6.14063 14.7148 6.64453 14.5508C6.92188 15.3828 7.26953 16.0977 7.67188 16.668C6.74609 16.3398 5.89844 15.8281 5.17578 15.1523ZM7.67578 14.2695C8.25781 14.1406 8.85547 14.0625 9.45312 14.0312V16.9141C8.78125 16.5586 8.12891 15.5898 7.67578 14.2695ZM10.5469 16.8984V14.0273C11.1406 14.0586 11.7305 14.1367 12.3047 14.2617C11.8594 15.5742 11.2109 16.5391 10.5469 16.8984ZM12.3047 16.6758C12.7109 16.1055 13.0625 15.3828 13.3398 14.5469C13.8477 14.7109 14.3477 14.918 14.8242 15.1562C14.0977 15.832 13.2383 16.3516 12.3047 16.6758ZM15.5664 14.3398C14.9414 14.0078 14.293 13.7344 13.625 13.5195C13.8437 12.5859 13.9727 11.5898 14.0078 10.5469H17.0391C16.9336 11.9336 16.4297 13.2383 15.5664 14.3398Z"
              fill="currentColor"
            />
          </svg>
          <div class="font-bold my-auto">
            {{ $t("appBar.overlayProfileSettings.language") }}
          </div>
        </div>

        <svg
          class="my-auto"
          width="20"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 18H14.75C16.1424 18 17.4777 17.4469 18.4623 16.4623C19.4469 15.4777 20 14.1424 20 12.75C20 11.3576 19.4469 10.0223 18.4623 9.03769C17.4777 8.05312 16.1424 7.5 14.75 7.5H5M7.5 4L4 7.5L7.5 11"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="px-2 py-2">
        <LocalLang />
      </div>
    </div>
    <!--/ if the toggleLanguagesMenu is true -->
    <div
      @click="logOutCurrentUser()"
      class="dark:bg-gray-700 bg-grayLightMode-100 rounded-b-curl py-2"
    >
      <div class="font-bold text-left px-5 cursor-pointer select-none">
        {{ $t("appBar.overlayProfileSettings.logOut") }}
      </div>
    </div>
  </div>
</template>

<script>
import LocalLang from "@/components/modules/LocalLang.vue";
import { mapGetters } from "vuex";

export default {
  name: "OverlayProfileSettings",
  components: { LocalLang },
  data() {
    return {
      isDark: this.$store.getters.getIsDark,
      toggleLanguagesMenu: false,
    };
  },
  watch: {
    // whenever isDark changes, this function will run
    "$store.state.isDark": function () {
      this.isDark = this.$store.state.isDark;
    },
  },
  computed: {
    // mapping to get current logged in user from store auth module
    ...mapGetters({ currentUser: ["authentication/getCurrentUser"] }),
  },
  methods: {
    // to logout current user
    logOutCurrentUser() {
      // passing `this` instance for later use in store
      this.$store.dispatch("authentication/logMeOut", this);
    },
    toggleDark() {
      this.$store.dispatch("toggleDarkAction"); // calling toggle action from store
    },
  },
};
</script>

<style lang="scss" scoped></style>
